<template>
  <div class="checkbox-wrapper">
    <div class="input-group">
      <input
          :id="`field-${id}`"
          ref="field"
          v-model="input"
          :name="name"
          class="push-v--mobile--small push-v--mobile--tablet push-v--desktop--small"
          type="checkbox"
          @change="change"
      >
      <span><Tick v-if="input" /></span>
      <label :for="`field-${id}`" v-html="label" />
    </div>
  </div>
</template>

<script>
import Tick from '~/assets/icons/tick.svg?inline';

export default {
  components: {
    Tick,
  },
  props: {
    validate: { type: String, required: false, default: null },
    label: { type: String, required: false, default: null },
    name: { type: String, required: true },
    value: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      input: false,
      id: null,
    };
  },
  mounted() {
    this.id = this._uid;
  },
  methods: {
    isChecked() {
      return this.input;
    },
    change() {
      this.$emit('input', this.input);
    },
  },
};
</script>
